import script from "./NextDrawsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextDrawsView.vue?vue&type=script&setup=true&lang=ts"

import "./NextDrawsView.vue?vue&type=style&index=0&id=00c4f514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c4f514"]])

export default __exports__